import { Component, HostListener, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material";

import { Observable } from "rxjs/Observable";
import { defaultIfEmpty } from "rxjs/operators";
import { Cotizacion } from "../../../models/cotizacion/cotizacion.model";

import { Paginacion } from "../../../models/paginacion/paginacion.model";
import { MisNegociosSandbox } from "../mis-negocios.sandbox";
import { BuscarDialogComponent } from "../shared/components/buscar-dialog/buscar-dialog.component";
import { ValidarDocumentoComponent } from "../shared/components/validar-documento/validar-documento.component";
import { ValidarSarlafComponent } from "../shared/components/validar-sarlaf/validar-sarlaf.component";

@Component({
  selector: "app-mis-negocios",
  templateUrl: "./mis-negocios.component.html",
  styleUrls: ["./mis-negocios.component.css"],
})
export class MisNegociosComponent implements OnInit {
  cotizaciones: Cotizacion[];
  paginacion: Paginacion;
  buscandoCotizaciones: Boolean = false;

  tiposDocumento$: Observable<any[]>;
  productos$: Observable<any[]>;

  displayedColumns = [
    "tomador",
    "solucion",
    "tipoOperacion",
    "fechaIngreso",
    "estadoNegocio",
    "codigoAsesor",
    "nombreAsesor",
    "acciones",
  ];
  selectedRowId: number;
  showScrollHeight: number;
  hideScrollHeight: number;
  showGoUpButton: boolean;

  constructor(
    private misNegociosSandbox: MisNegociosSandbox,
    private dialog: MatDialog
  ) { }

  ngOnInit() {
    this.tiposDocumento$ = this.misNegociosSandbox.buscarTiposDocumento();
    this.productos$ = this.misNegociosSandbox.buscarProductos();

    this.misNegociosSandbox.capturarDetalleNavbar().subscribe((res) => {
      if (res !== '0') {
        this.initCotizaciones();
      }
    });
  }

  private async initCotizaciones() {
    this.selectedRowId = -1;
    this.showScrollHeight = 400;
    this.hideScrollHeight = 200;
    this.showGoUpButton = false;

    this.paginacion = {
      pagina: 0,
      filasPorPagina: 100,
      columnaOrdenamiento: "fechaCotizacion",
      direccionOrdenamiento: -1,
    } as Paginacion;

    this.buscandoCotizaciones = true;
    (await this.misNegociosSandbox
      .getCotizaciones(this.paginacion))
      .pipe(defaultIfEmpty([]))
      .subscribe((res) => {
        this.cotizaciones = res;
        this.buscandoCotizaciones = false;
      });
  }

  onScroll() {
    if (this.buscandoCotizaciones) return false;
    this.buscandoCotizaciones = true;
    this.paginacion.pagina++;
    this.misNegociosSandbox.getCotizacionesByPage(this.paginacion)
      .subscribe((res) => {
        this.cotizaciones = this.cotizaciones.concat(res);
        this.buscandoCotizaciones = false;
      });
  }

  scrollTop() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }

  @HostListener("window:scroll", [])
  onWindowScroll() {
    let isScrollUp = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
    let isScrollDown = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;

    if (isScrollUp > this.showScrollHeight) {
      this.showGoUpButton = true;
    } else if (this.showGoUpButton && isScrollDown < this.hideScrollHeight) {
      this.showGoUpButton = false;
    }
  }

  refrescar() {
    this.initCotizaciones();
  }

  openDialogBuscar() {
    let dialogRef = this.dialog.open(BuscarDialogComponent, {
      width: "650px",
      disableClose: true,
      data: {
        tiposDocumento: this.tiposDocumento$,
        productos: this.productos$
      }
    });

    dialogRef.afterClosed().subscribe(async (filtros) => {
      if (filtros) {
        this.paginacion.pagina = 0;
        (await this.misNegociosSandbox.filtrarCotizaciones(filtros, this.paginacion))
          .subscribe((res) => {
            this.cotizaciones = res;
          });
      }
    });
  }

  showActions(row) {
    const buttonMenu = document.getElementById(row.nroCotizacion) as HTMLElement;
    const menu = document.getElementsByClassName("mat-menu-content");

    if (menu.length == 0) {
      buttonMenu.click();
    }
    this.selectedRowId = row.nroCotizacion;
  }

  performAction(action) {
    switch (action.codigo) {
      case "VER":
      case "RECALCULAR":
      case "ADJUNTAR_REQUISITOS":
        this.misNegociosSandbox.redirigir(action.plantillaUrl);
        break;
      case "VALIDAR_DOCUMENTO":
        this.openDialogValDocumento(this.selectedRowId);
        break;
      case "VALIDAR_SARLAFT":
        this.openDialogValSarlaft(this.selectedRowId);
        break;
      default:
        break;
    }
  }

  private openDialogValDocumento(nroCotizacion: number) {
    let responseValDoc = this.misNegociosSandbox.validarDocumento(nroCotizacion);

    let dialogRef = this.dialog.open(ValidarDocumentoComponent, {
      width: "650px",
      disableClose: true,
      data: responseValDoc
    });

    dialogRef.afterClosed().subscribe((nroDocumento) => {
      if (nroDocumento) {
        this.misNegociosSandbox
          .reenviarDocumento(nroDocumento)
          .subscribe((res) => {
            this.misNegociosSandbox.mostrarMensaje("La notificación ha sido reenviada al cliente");
          });
      }
    });
  }

  private openDialogValSarlaft(nroCotizacion: number) {
    let responseSarlaft = this.misNegociosSandbox.validarSarlaft(nroCotizacion);

    this.dialog.open(ValidarSarlafComponent, {
      width: "650px",
      disableClose: true,
      data: responseSarlaft,
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/mis-negocios/pages/mis-negocios.component.ts